/* eslint-disable react/jsx-no-undef */
import { FormHelperText, TextField } from "@mui/material";
import { MprcContainer, MprcFormSubHeader, MprcStringToHtml } from "components";
import { MprcNumberField } from "components/MprcNumberField";
import { MprcSwitch } from "components/MprcSwitch";
import { ManagedQuestionResponse, QuestionClass } from "generated/CoreApi_v1";
import React from "react";
import { useTranslation } from "react-i18next";
import { useQuestionContext } from "views/assessment/questionBank/Home/EditQuestion/EditQuestion";

////////////////////////////////////////////////////////////////////////////////

export interface IValidationFieldsEssay {
    maxLen: boolean;
}

export interface IPostValidationEssay {
    maxLen: string[] | undefined;
    alternatives: string[] | undefined;
}

export function validateEssay(dto: ManagedQuestionResponse): IValidationFieldsEssay {
    return {
        maxLen: dto.maxLen != undefined && dto.maxLen > 0,
    };
}

/////////////////////////////////////////////////////////////////////////////////

export const EditQuestionEssay: React.FC = () => {

    const { viewData, postValidation, validationFields, readonly, handleUpdateRecord, handleUpdateSurvey } = useQuestionContext();

    const { t } = useTranslation("assessment");

    const currentPostValidation = postValidation.essayBox;
    const currentValidationFields = validationFields.essayBox;

    ////////////////////////////////////////////////////////////////////////////
    /// RENDER
    ////////////////////////////////////////////////////////////////////////////

    return (
        <>
            {
                viewData.questionClass == QuestionClass.Survey &&
                    <MprcContainer>
                        <MprcSwitch
                            label={t("Question.Edit.Essay.EssayAnswerRequiredLabel")}
                            checked={viewData.survey?.essayAnswerRequired ?? false}
                            disabled={readonly}
                            onChange={(e) => handleUpdateSurvey("essayAnswerRequired", e.target.checked)}
                        />
                    </MprcContainer>
            }
            <MprcContainer>
                <MprcFormSubHeader
                    title={t("Question.Edit.Essay.PlaceholderTextLabel")}
                />
                <TextField
                    fullWidth
                    name="placeholderText"
                    autoComplete="off"
                    margin="dense"
                    value={viewData.placeholderText || ""}
                    onChange={(e) => handleUpdateRecord("placeholderText", e.target.value)}
                    multiline
                    disabled={readonly}
                    maxRows={3}
                />
            </MprcContainer>
            <MprcContainer>
                <MprcFormSubHeader
                    title={t("Question.Edit.Essay.MaxLenLabel")}
                />
                <MprcNumberField
                    value={viewData.maxLen}
                    disabled={readonly}
                    min={10}
                    max={1000}
                    fullWidth={false}
                    defaultValue={1}
                    sx={{ width: 200 }}
                    onChange={(value) => handleUpdateRecord("maxLen", value)}
                    slotProps={{ input: { endAdornment: t("Question.Edit.Essay.CharactersLabel") } }}
                    error={(viewData.maxLen != null && !currentValidationFields.maxLen) || !!currentPostValidation.maxLen}
                    helperText={currentPostValidation?.maxLen&& <FormHelperText error>{<MprcStringToHtml text={currentPostValidation?.maxLen} />}</FormHelperText>}
                />
            </MprcContainer>
            {
                !!currentPostValidation.alternatives &&
                <FormHelperText error>{<MprcStringToHtml text={currentPostValidation?.alternatives} />}</FormHelperText>
            }
        </>
    );
};
